/* Scope only the catalogue/product sidebar; preserve the theme's page scrolling. */
(()=>{
 const side=document.querySelector('.ar-product-sidebar, #main-collection-filters');
 if(!side)return;
 const product=side.classList.contains('ar-product-sidebar');
 const boundary=side.parentElement;
 const slot=document.createElement('div');slot.className='ar-side-slot';
 boundary.insertBefore(slot,side);slot.appendChild(side);
 const media=matchMedia('(min-width:750px)');
 const shell=side.querySelector('.ar-side-shell');
 const reset=()=>{side.classList.remove('ar-side-is-fixed');for(const p of ['position','top','left','width','max-height'])side.style.removeProperty(p);};
 const responsive=()=>{reset();slot.style.cssText=media.matches?(product?'':'flex:0 0 26rem;width:26rem;'):'';if(shell)shell.open=media.matches;update();};
 const update=()=>{
   if(media.matches){reset();slot.style.minHeight='';return;}
   if(document.body.className.includes('overflow-hidden'))return;
   const header=document.querySelector('.section-header');
   const hr=header?.getBoundingClientRect();
   const top=Math.max(0,Math.min(innerHeight*.4,hr?hr.bottom:0))+12;
   const rect=slot.getBoundingClientRect(),end=boundary.getBoundingClientRect().bottom;
   const space=Math.max(60,innerHeight-top-16);
   if(rect.top<top&&end>top){
     side.classList.add('ar-side-is-fixed');side.style.position='fixed';side.style.left=rect.left+'px';side.style.width=rect.width+'px';side.style.maxHeight=space+'px';
     side.style.top=Math.min(top,end-Math.min(side.scrollHeight,space)-8)+'px';
   }else reset();
   slot.style.minHeight=Math.min(side.scrollHeight,space)+'px';
 };
 let queued=false;const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;update();});}};
 addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);media.addEventListener('change',responsive);
 side.addEventListener('toggle',schedule,true);responsive();
})();

/* Keep product recommendations before the shared contact form. */
(()=>{
  const arrange=()=>{
    const recommendations=document.querySelector("#MainContent product-recommendations.related-products");
    const section=recommendations?.closest(".shopify-section");
    const content=section?.closest(".ar-product-content");
    const contact=content?.querySelector(".ar-shared-contact");
    if(section&&content&&contact&&section.nextElementSibling!==contact){
      content.insertBefore(contact,section.nextSibling);
    }
  };
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",arrange,{once:true});
  else arrange();
  document.addEventListener("shopify:section:load",arrange);
})();

(()=>{
 const side=document.querySelector('#main-collection-filters');
 const shell=side?.querySelector('.ar-side-shell[data-mobile-collapsed]');
 if(!shell)return;
 const nav=shell.querySelector('.ar-side-nav');
 const native=side.querySelector('.facets-container > facet-filters-form.facets');
 const sorting=document.querySelector('.facets-vertical-sort');
 if(!native||!sorting||!nav)return;
 const nativeHome=document.createComment(''),sortHome=document.createComment('');
 native.before(nativeHome);sorting.before(sortHome);
 const media=matchMedia('(max-width:749px)');
 const arrange=()=>{
  if(media.matches){shell.classList.add('ar-unified-filters');nav.prepend(sorting,native);side.classList.add('ar-unified-mobile');}
  else{sortHome.after(sorting);nativeHome.after(native);shell.classList.remove('ar-unified-filters');side.classList.remove('ar-unified-mobile');}
 };
 media.addEventListener('change',arrange);arrange();
})();

(()=>{
  const place=()=>{
    const layout=document.querySelector(".ar-product-layout");
    const description=layout?.querySelector(".product-description");
    const contact=layout?.querySelector(".ar-shop-contact");
    const button=contact?.querySelector("a");
    if(!description||!contact||!button)return;
    button.classList.remove("button","button--secondary");
    button.classList.add("ar-side-contact");
    if(contact.parentElement!==description)description.append(contact);
  };
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",place,{once:true});
  else place();
  document.addEventListener("shopify:section:load",place);
})();
(()=>{
  const selector=".card__heading a,product-info .product__title h1";
  const normalize=(root)=>{
    const titles=[...(root.matches?.(selector)?[root]:[]),...root.querySelectorAll(selector)];
    titles.forEach(title=>{
      if(title.children.length)return;
      const original=title.textContent.trim();
      if(!original||original!==original.toLocaleUpperCase()||original===original.toLocaleLowerCase())return;
      const words=original.split(/(\s+)/).map(word=>/\d/.test(word)?word:word.toLocaleLowerCase());
      const text=words.join("").replace(/[a-záéíóúüñ]/i,letter=>letter.toLocaleUpperCase());
      if(text!==original)title.textContent=text;
    });
  };
  const start=()=>{
    const main=document.querySelector("#MainContent");
    if(!main)return;
    normalize(main);
    new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)normalize(node);}))).observe(main,{childList:true,subtree:true});
  };
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start,{once:true});else start();
})();
(()=>{
  const arrangeDescriptionActions=()=>{
    const description=document.querySelector(".ar-product-layout .product-description");
    const contact=description?.querySelector(".ar-shop-contact");
    const quality=description?.querySelector("a[href*=calidad-del-diamante]");
    if(!contact||!quality||quality.parentElement===contact)return;
    const wrapper=quality.closest("li,p");
    const list=wrapper?.parentElement;
    quality.classList.add("ar-description-quality");
    contact.append(quality);
    if(wrapper&&wrapper!==contact&&!wrapper.textContent.trim()&&!wrapper.querySelector("img,a"))wrapper.remove();
    if(list?.matches("ul,ol")&&!list.children.length)list.remove();
  };
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",arrangeDescriptionActions,{once:true});else arrangeDescriptionActions();
  document.addEventListener("shopify:section:load",arrangeDescriptionActions);
})();
